<div class="attribute-grid">
  <div class="attribute-label">
    <span class="md:pr-4">
      <app-copy-to-clipboard value="{{label}} - {{value}}">{{label}}</app-copy-to-clipboard>
    </span>
  </div>
  @if (value) {
    <div class="flex items-center mb-2 md:mb-0 md:h-12 md:px-4">
      <app-copy-to-clipboard value="{{value}}">{{value}}</app-copy-to-clipboard>
    </div>
  } @else {
    <ng-content></ng-content>
  }
</div>

